import React from "react";
import { IGame, GamesCollection } from "../interfaces/intefaces";
import Game from "./Game";

interface IProps {
  games: GamesCollection | undefined
  updateCategory: (category_id: number, hotGame: number, newGame: number) => void,
  userIsLoggedIn: boolean
  openModal: (game: IGame, for_fun:boolean) => void
}

const HotGames: React.FC<IProps> = ({ games, updateCategory, userIsLoggedIn, openModal }) => {

  const handleGameClick = (game: IGame, loginRequired: boolean = true, for_fun:boolean = false) => {
    if (!userIsLoggedIn && loginRequired) {
      const el = document.getElementById('login-button')
      if (el !== null) {
        el.click();
      }
      return false;
    }
    openModal(game, for_fun);

    return true;
  }

  return (
    <>
      <div className="games-section  games-hot">
        <div className="title-wrap">
          <h2 className="title-1">HOT GAMES</h2>
          <div className="hr"></div>
          <div className="text-right"><button onClick={() => { updateCategory(-1, 1, 0); }} className="btn-primary">SEE ALL
          </button></div>
        </div>
        <div className="games-inner">
          <div className="games">
            {(games !== undefined) && games.games.map(game => {
              return (
                <Game game={game} key={game.id} handleGameClick={handleGameClick} />
              )
            }
            )}
          </div>
        </div>

      </div>
    </>
  )
}

export default HotGames;